// extracted by mini-css-extract-plugin
export default {"rowContainer":"SWOT_rowContainer__TQ9DW"};